import { ReactQueryDevtools } from "@tanstack/react-query-devtools"
import { TanStackRouterDevtools } from "@tanstack/react-router-devtools"

import { CaptchaProvider } from "@repo/captcha/captcha-provider"
import { CaptchaTokenSetter } from "@repo/captcha/captcha-token-setter"
import { ThemeProvider } from "@repo/ui/components/theming/theme-provider"
import { Toaster } from "@repo/ui/components/ui/sonner"
import { sharedConfig } from "~/lib/config/shared"
import { VersionCheck } from "../version-check"
import { PostHogProvider } from "./posthog-provider"

export type ProvidersProps = {
  children: React.ReactNode
}

export function AppProviders({ children }: ProvidersProps) {
  return (
    <ThemeProvider defaultTheme="system" storageKey="theme" forcedTheme="light">
      <PostHogProvider>
        <CaptchaProvider enabled={sharedConfig.flags.captchaEnabled}>
          <CaptchaTokenSetter siteKey={sharedConfig.captchaSiteKey} />
          {children}
        </CaptchaProvider>
      </PostHogProvider>
      <Toaster position="top-center" richColors theme="dark" />
      <TanStackRouterDevtools position="bottom-right" />
      <ReactQueryDevtools buttonPosition="bottom-right" />
      <VersionCheck />
    </ThemeProvider>
  )
}
